import moment from 'moment-timezone'

const MINUTES_SHOWN_AS_MINUTES_BELOW = 120

export const getPressureAgeText = ({
  language,
  nowMs,
  timestamp,
}: {
  language: string
  nowMs: number
  timestamp: string
}) => {
  const readingMs = moment.tz(timestamp, moment.ISO_8601, 'UTC').valueOf()

  if (Number.isNaN(readingMs)) return ''

  return moment
    .duration(Math.min(readingMs - nowMs, 0))
    .locale(language)
    .humanize(true, { m: MINUTES_SHOWN_AS_MINUTES_BELOW })
}
